"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageObject = void 0;
const Shape_1 = require("lincd/lib/shapes/Shape");
const models_1 = require("lincd/lib/models");
const package_1 = require("../package");
const schema_1 = require("../ontologies/schema");
const Server_1 = require("lincd-server-utils/lib/utils/Server");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
let ImageObject = class ImageObject extends Shape_1.Shape {
    get contentUrl() {
        return this.getValue(schema_1.schema.contentUrl);
    }
    set contentUrl(val) {
        this.overwrite(schema_1.schema.contentUrl, new models_1.Literal(val));
    }
    static deleteFile(filePath) {
        return Server_1.Server.call(this, 'deleteFile', filePath);
    }
    static getAllFilestoreImages() {
        return Server_1.Server.call(this, 'getAllFilestoreImages');
    }
    static fromDataURL(dataURL, filename) {
        return Server_1.Server.call(this, 'fromDataURL', dataURL, filename);
    }
    static fromBlob(blob, filename) {
        //https://stackoverflow.com/a/29390393/977206
        let file = new File([blob], filename, { type: blob.type });
        return this.fromFormFile(file);
    }
    /**
     * @param file
     * @param name optionally specify a name for the file
     */
    static fromFormFile(file, name) {
        var formData = new FormData();
        formData.append('upload', file, name || file.name);
        //content-type needs to specifically be left UNDEFINED
        //https://stackoverflow.com/questions/39280438/fetch-missing-boundary-in-multipart-form-data-post
        // var headers = {
        //   Accept: 'application/json, text/plain, */*',
        // };
        //
        // return Server.call(new ImageObject(), {
        //   method:'fromFormFile',
        //   headers
        // }, formData) as Promise<ImageObject>;
        // return Server.call(new ImageObject(), 'fromFormFile', formData) as Promise<ImageObject>;
        return Server_1.Server.callCustomShapeMethod(this, 'POST', 'fromFormFile', formData, {
            Accept: 'application/json, text/plain, */*',
            //content-type needs to specifically be left UNDEFINED
            //https://stackoverflow.com/questions/39280438/fetch-missing-boundary-in-multipart-form-data-post
        });
    }
    static fromFormFiles(files) {
        var formData = new FormData();
        for (var key in files) {
            if (files.hasOwnProperty(key)) {
                formData.append('upload-' + key, files[key], files[key].name);
            }
        }
        return null;
        //content-type needs to specifically be left UNDEFINED
        //https://stackoverflow.com/questions/39280438/fetch-missing-boundary-in-multipart-form-data-post
        // var headers = {
        //   Accept: 'application/json, text/plain, */*',
        // };
        //
        // return Server.call(new ImageObject(), {
        //   method:'fromFormFiles',
        //   headers
        // }, formData) as Promise<ShapeSet<ImageObject>>;
        // return Server.call(ImageObject, 'fromFormFiles', formData) as Promise<ImageObject>;
    }
};
exports.ImageObject = ImageObject;
ImageObject.targetClass = schema_1.schema.ImageObject;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.contentUrl,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], ImageObject.prototype, "contentUrl", null);
exports.ImageObject = ImageObject = __decorate([
    package_1.linkedShape
], ImageObject);
//# sourceMappingURL=ImageObject.js.map